import React from 'react'
import { useTranslation } from "react-i18next"

function Content_Investigation() {
    const { t } = useTranslation();
    return (
        <>
           <div class="image-head p-relative">
                <div class="before-z-index" data-dsn-grid="move-up" data-overlay="5">
                    <img class="cover-bg-img has-bigger-scale" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-dsn-src="assets/images/investigation_page.png" alt="Investigation" />
                </div>
            </div>
            <div>
                <br />  
                <div className="content_about">
                    <p className="sub-heading line-shap line-shap-after mb-15">
                        <span className="line-bg-left font-small-title"> {t('services.inv.title')}</span>
                    </p>
                    <br />
                    <div className="post-content p-services">
                        <p>
                        {t('services.inv.para1')}
                        <br /><br />
                        {t('services.inv.para2')}
                        <br /> <br />
                        {t('services.inv.para3')}
                        <br /> <br />
                        </p>
                        <ol>
                            <li className="Investigation-li"><p>{t('services.inv.li1')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li2')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li3')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li4')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li5')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li6')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li7')}</p></li>
                            {/* <li className="Investigation-li"><p>{t('services.inv.li8')}</p></li>
                            <li className="Investigation-li"><p>{t('services.inv.li9')}</p></li> */}
                        </ol>
                    </div>
                </div>

            </div> 
        </>
    )
}

export default Content_Investigation
